import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { BookExtraResourceStatus, BookExtraResourceType } from '../../../../ui/src/common/book/BookHelpers';

const BookExtraResource: React.FC<{ extraResources: any[] }> = ({
  extraResources,
}) => {
  const [extend, setExtend] = useState(false);
  const extras = useMemo(() => {
    return extraResources.filter(
      (e) =>
        !!e.name &&
        !!e.link &&
        e.status === BookExtraResourceStatus.Show &&
        (e.type === BookExtraResourceType.All),
    );
  }, [extraResources]);
  return (
    <div
      className="ms-2 extra-resource"
      style={extras?.length > 0 ? {} : { display: 'none' }}>
      <div className="top-icon" onClick={() => {
        setExtend(!extend);
      }}>
        <span className="pe-2">
          {'Tài liệu mở rộng' /*Translate('extra-resource', 'Tài liệu mở rộng')*/}
        </span>
        <FontAwesomeIcon
          className="ms-2"
          icon={!extend ? faCaretDown : faCaretUp}
        />
      </div>
      {extend && (
        <div className="extend">
          {extras.map((i) => (
            <React.Fragment key={i}>
              <hr />
              <a href={i.link} target="_blank" rel="noreferrer">
                <ul>{i.name}</ul>
              </a>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};
export default BookExtraResource;
